module.exports = __webpack_public_path__ + "static/turquia-014.thumb-55412d40486c5eb48ff1cfda8773eb31.jpg";